export default __webpack_public_path__ + "static/031-207efa77348dfd584766d0343a0f4ef8.jpg";